import { ButtonProps, ButtonTypes } from "./interface";
import TextButton from "./components/TextButton";
import IconButton from "./components/IconButton";
import LabelledIconButton from "./components/LabelledIconButton";
import { forwardRef } from "react";

const Button = forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
    const { type } = props;

    switch (type) {
        case ButtonTypes.TextButton:
            return <TextButton {...props} />;
        case ButtonTypes.IconButton:
            return <IconButton ref={ref} {...props} />;
        case ButtonTypes.LabelledIconButton:
            return <LabelledIconButton {...props} />;
    }
});

export default Button;
